if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.sticky-atc__button');
        this.footer = document.querySelector('footer.footer') || document.querySelector('footer');
        this.pastRealButton = false;
        this.beforeFooter = true;

        // Real add-to-cart button: once it scrolls above the viewport, the
        // sticky bar is allowed to show.
        var realButton = document.querySelector(`#ProductSubmitButton-${this.dataset.formId.replace('product-form-', '')}`);
        if (realButton) {
          this.buttonObserver = new IntersectionObserver(
            (entries) => {
              this.pastRealButton = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
              this.update();
            },
            { threshold: 0 }
          );
          this.buttonObserver.observe(realButton);
        } else {
          this.pastRealButton = true;
        }

        // Footer: once it enters the viewport, hide the sticky bar so it
        // never sits on top of footer content.
        if (this.footer) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              this.beforeFooter = !entries[0].isIntersecting;
              this.update();
            },
            { threshold: 0, rootMargin: '0px 0px 0px 0px' }
          );
          this.footerObserver.observe(this.footer);
        }

        // Keep the sticky form's disabled/sold-out state in sync with the
        // real submit button when the variant selection changes.
        document.addEventListener('change', () => {
          requestAnimationFrame(() => this.syncButtonState(realButton));
        });

        this.update();
      }

      syncButtonState(realButton) {
        if (!realButton || !this.button) return;
        this.button.disabled = realButton.disabled;
        var label = realButton.querySelector('span');
        if (label) this.button.textContent = label.textContent.trim();
      }

      update() {
        var visible = this.pastRealButton && this.beforeFooter;
        this.classList.toggle('sticky-atc--visible', visible);
        document.documentElement.classList.toggle('has-sticky-atc', visible);
      }

      disconnectedCallback() {
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        document.documentElement.classList.remove('has-sticky-atc');
      }
    }
  );
}
